/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Reward: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="reward" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M679.6175 1159.4425L1094.8 919.7425V440.3L679.6175 200.5999999999999L264.4349999999999 440.3V919.7425L679.6175 1159.4425zM1170.365 963.3475L679.6175 1246.695L188.87 963.3475V396.695L679.6175 113.3475000000001L1170.365 396.6950000000002V963.3475zM680 944.435L760.07 780.555L944.435 756.84L809.5825 631.8475000000001L843.455 453.3050000000001L680 539.9200000000001L516.545 453.3050000000001L550.4175 631.8475000000001L415.565 756.84L599.93 780.555L680 944.435z" : "M543.694 927.554L875.8399999999999 735.794V352.24L543.694 160.48L211.5479999999999 352.24V735.794L543.694 927.554zM936.292 770.678L543.694 997.356L151.096 770.678V317.356L543.694 90.6780000000001L936.292 317.3560000000001V770.6780000000001zM544 755.548L608.056 624.444L755.548 605.472L647.6659999999999 505.4780000000001L674.764 362.644L544 431.9360000000001L413.236 362.644L440.334 505.4780000000001L332.452 605.472L479.944 624.444L544 755.548z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Reward.displayName = `Blueprint5.Icon.Reward`;
export default Reward;
